import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-legal-conditions',
  templateUrl: './formly-legal-conditions.component.html',
  styleUrls: ['./formly-legal-conditions.component.scss'],
})
export class FormlyLegalConditionsComponent
  extends FieldType
  implements OnInit {
  @Input() helpertext: string;
  @Input() label: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() required?: boolean;
  @Input() invalidtext: string;
  @Input() disabled?: boolean;
  @Input() termsAndConditions?: string;
  checked = false;

  ngOnInit(): void {
    if (this.to.required) {
      this.field.formControl.setValidators([
        Validators.required,
        Validators.requiredTrue,
      ]);
    }

    this.label = this.to.label;
    this.placeholder = this.to.placeholder;
    this.helpertext = this.to.helpertext;
    this.required = this.to.required;
    this.name = this.key.toString();
    this.invalidtext = this.to.invalidtext;
    this.disabled = this.to.disabled;
    this.termsAndConditions = this.to.defaultValue;
    this.field.formControl.patchValue(this.checked);
  }
  onCheckboxChangeEvent($event) {
    this.field.formControl.patchValue($event);
  }
}
